module.exports = __webpack_public_path__ + "media/images/sarabia-logo@2x-196982ef54c8c4f26528c800eec9f317.webp";